import { assertNever } from '../errors.js';
import { auJurisdiction } from './au.js';
import { gbJurisdiction } from './gb.js';
import { usJurisdiction } from './us.js';
export const jurisdictionFor = (code = 'AU') => {
    switch (code) {
        case 'AU': return auJurisdiction;
        case 'GB': return gbJurisdiction;
        case 'US': return usJurisdiction;
        default: return assertNever(code, 'jurisdiction');
    }
};
export const taxContextFromProfile = (p, extras = {}) => ({
    entityType: p.entityType,
    marginalRate: p.marginalRate,
    medicareLevy: p.medicareLevy,
    ...(p.cgt2027ValuationMethod ? { valuation2027: p.cgt2027ValuationMethod } : {}),
    pensionPhaseProportion: p.smsf?.pensionPhaseProportion ?? 0,
    ...extras,
});
//# sourceMappingURL=jurisdiction.js.map